import { ToastProvider } from "./Toast.tsx"

/**
 *
 * This component is needed for BaseUI to work properly
 * This makes sure that portalled component are always on top of other components
 * https://base-ui.com/react/overview/quick-start#set-up-portals
 */
export const BaseUIWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <ToastProvider>
      <div className="isolate">{children}</div>
    </ToastProvider>
  )
}
